// These markers are set by the bounded server-response adapters. Presentation
// is not permission to trade: command authorisation remains server-owned.
export const isServerFeedPresentation = (item) =>
  item?._authorityPresentation === true ||
  item?._legacyCompatibilityPresentation === true;

export const feedTypeSelection = (filters) => {
  // The toolbar exposes a subset of content kinds. Selecting everything means
  // the complete feed, including text/embed posts without a dedicated toggle.
  if (filters.length && filters.every((filter) => filter.active)) return "";
  return filters.filter((filter) => filter.active)
    .map((filter) => filter.type).join(",") || "__none__";
};
